import React from 'react'
import { Box, Icon, Paragraph } from '@ui'

type Props = {
    rank: number
    size?: 'square_xs' | 'square_sm' | 'square_md'
}

export const MedalIcon = ({ rank, size = 'square_md' }: Props) => {
    if (rank === 1) {
        return <Icon type="goldMedal" size={size} />
    }
    if (rank === 2) {
        return <Icon type="silverMedal" size={size} />
    }
    if (rank === 3) {
        return <Icon type="bronzeMedal" size={size} />
    }
    // For ranks > 3, display the number
    return (
        <Box centerContent width="x4" height="x3">
            <Paragraph
                width="x3"
                textAlign="center"
                style={{ fontVariantNumeric: 'tabular-nums' }}
                color="gray2"
            >
                {rank}
            </Paragraph>
        </Box>
    )
}
